import type { CartItem } from './types'

const STORAGE_KEY = 'cart-list'

export function addToCart(item: CartItem): number {
  const currentList = getCartItems()
  const existingItemIndex = currentList.findIndex(
    (i) =>
      i.id === item.id &&
      i.type === item.type &&
      JSON.stringify(i.parameters) === JSON.stringify(item.parameters)
  )

  if (existingItemIndex !== -1) {
    currentList[existingItemIndex].quantity += item.quantity
  } else {
    currentList.push(item)
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(currentList))
  return currentList.length
}

export function removeFromCart(item: CartItem) {
  const currentList = getCartItems()
  const updatedList = currentList.filter(
    (i) =>
      !(
        i.id === item.id &&
        i.type === item.type &&
        JSON.stringify(i.parameters) === JSON.stringify(item.parameters)
      )
  )

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList))
}

export function updateCartItem(item: CartItem) {
  const currentList = getCartItems()
  const existingItemIndex = currentList.findIndex(
    (i) =>
      i.id === item.id &&
      i.type === item.type &&
      JSON.stringify(i.parameters) === JSON.stringify(item.parameters)
  )

  if (existingItemIndex !== -1) {
    currentList[existingItemIndex] = item
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentList))
  }
}

export function getCartItems(): CartItem[] {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored ? JSON.parse(stored) : []
}

export function clearCart() {
  localStorage.removeItem(STORAGE_KEY)
}
